import React from "react";
import styles from "./ProjectGrid.module.css";
import SectionHeader from "./SectionHeader";
import PortfolioFooter from "./PortfolioFooter";

export const projects = [
  {
    title: "InversionX",
    desc: "Streamlined dependency injection and type handling.",
    link: "Other",
    image: "/github.webp",
    tags: ["Typescript", "Open Source", "Other"],
    github: "https://github.com/JohnGJackson0/InversionX",
  },
  {
    title: "React Native Auth Starter",
    desc: "Built a full authentication boilerplate using AWS & React Native for SaaS MVPs.",
    image: "/auth3.png",
    link: "React Native",
    tags: ["React Native", "AWS", "Typescript", "Open Source"],
    github:
      "https://github.com/JohnGJackson0/react_native_clean_architecture_login_template",
  },
  {
    title: "Godo Tasks",
    desc: "A cloud-based task management application built with Firebase.",
    image: "/godo4.png",
    link: "React Native",
    tags: ["React Native", "Firebase", "Typescript"],
    github: "https://github.com/JohnGJackson0/GoDo",
  },
  {
    title: "Quick Notes",
    desc: "Capture your thoughts in an instant and get reminded at the perfect place or time.",
    image: "/quicknotes1.png",
    tags: ["React Native", "Typescript"],
    link: "React Native",
    github: "https://github.com/JohnGJackson0/Quick-Notes",
  },
  {
    title: "GoStat!",
    desc: "Your Student-Friendly Stat Calculator.",
    image: "/gostat1.png",
    tags: ["Android", "Java"],
    link: "Android",
    github: "https://github.com/JohnGJackson0/GoStat",
  },
  {
    title: "Inventory Management System",
    desc: "Inventory Management System for a local business.",
    image: "/auto2.png",
    link: "IMS",
    tags: ["Android", "Java"],
    github: "https://github.com/JohnGJackson0/IMSAutoPartsStore",
  },
  {
    title: "Staty",
    desc: "Elemantary Stat Calculator.",
    image: "/staty1.png",
    link: "Flutter",
    tags: ["Flutter", "Dart"],
    github: "https://github.com/JohnGJackson0/staty",
  },
];

export default function ProjectGrid({ filter }: { filter?: string }) {
  const filtered = filter
    ? projects.filter((p) => p.tags.includes(filter))
    : projects;
  return (
    <div>
      <section id="projects" className={styles["project-section"]}>
        <div className={styles["projects-header"]}>
          <SectionHeader title="Projects" />
        </div>
        <div className={styles["project-grid"]}>
          {filtered.map((project, idx) => (
            <div className={styles["project-card"]} key={project.title}>
              <div className={styles["phone-frame"]}>
                <img src={project.image} alt={project.title + " screenshot"} />
              </div>
              <div className={styles["project-title"]}>{project.title}</div>
              <div className={styles["project-desc"]}>{project.desc}</div>
              <div className={styles["project-tags"]}>
                {project.tags.map((tag) => (
                  <span className={styles["project-tag"]} key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
              <div className={styles["project-actions"]}>
                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className={styles["project-btn"]}>
                    View on GitHub
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
